"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationPage = void 0;
const OrganizationDto_1 = require("../dto/OrganizationDto");
const EsText_1 = require("./EsText");
class OrganizationPage {
    constructor(content) {
        this.id = 0;
        this.parentId = 0;
        this.code = "";
        this.state = OrganizationDto_1.OrganizationPageStateDto.DRAFT;
        this.title = "";
        this.titleShort = "";
        this.order = 0;
        this.childIds = [];
        this.content = content;
    }
    get shortTitleOrTitle() {
        return this.titleShort ? this.titleShort : this.title;
    }
    static fromDto(dto) {
        const content = EsText_1.EsText.fromOptionalTextDto(dto.content);
        const result = new OrganizationPage(content);
        result.id = dto.id;
        if (dto.parentId) {
            result.parentId = dto.parentId;
        }
        result.state = dto.state;
        result.title = dto.title;
        if (dto.titleShort) {
            result.titleShort = dto.titleShort;
        }
        if (dto.code) {
            result.code = dto.code;
        }
        result.order = dto.order;
        if (dto.childIds) {
            result.childIds = dto.childIds;
        }
        return result;
    }
    toDto() {
        const resultDto = {
            state: this.state,
            title: this.title,
        };
        if (this.code) {
            resultDto.code = this.code;
        }
        if (this.titleShort) {
            resultDto.titleShort = this.titleShort;
        }
        if (this.content.notEmpty) {
            resultDto.content = this.content.toOptionalTextDto();
        }
        return resultDto;
    }
}
exports.OrganizationPage = OrganizationPage;
